<template>
  <v-autocomplete
    :loading="loading"
    :items="items"
    item-text="name"
    item-value="id"
    v-model="model"
    :label="label"
    :disabled="isDisabled"
    :rules="rules"
  >
  <template v-slot:item="{ item }">
    <v-list-item-content>
      <v-list-item-title>{{item.name}}</v-list-item-title>
      <v-list-item-subtitle>{{ item.taxRate }}%</v-list-item-subtitle>
    </v-list-item-content>
  </template>
  </v-autocomplete>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data : () => ({
    items: [],
    loading: false
  }),
  props: {
    value: {
      type: [String, Number]
    },
    label: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    locationId: {
      type: Number,
      default: null
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isDisabled() {
      return this.disabled || this.items.length == 0 || this.loading
    },
    model: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit("input", v);
      }
    }
  },
  watch: {
    locationId () {
      this.fetch()
    }
  },
  mounted () {
    this.fetch()    
  },

  methods: {
    ...mapActions('taxRates', {fetchTaxRates:'index', getByLocation: 'getByLocation'}),
    fetch () {
      this.loading=true;
      this.getByLocation()
        .then(({tax_rates}) => {
          this.items=tax_rates
        })
        .finally(() => {
          this.loading=false
        })
    }
  }

};
</script>

<style>
</style>